export const ADDRESS_DETAIL_TEXTS = {
    MAIN_TITLE: "Tu dirección en Miami para",
    TERMS_CONDITIONS_TEXT: "Revisa los ",
    TERMS_CONDITIONS_TEXT2: "términos, condiciones, tarifas e instrucciones de uso aquí",
    DOUBTS_TEXT: "─── ¿Tienes dudas?,",
    CONTACT_US_TEXT: "Contáctanos",
};